<div class="bmc-working-time-schema-detail">
  <div class="bmc-working-time-schema-detail__grid">
    <div class="bmc-working-time-schema-detail__section bz-space--inline-m bz-space--stack-s">
      <strong class="bz-space--stack-xs bmc-working-time-schema-detail__label">{{'USER_GROUPS_BY_USER.SEARCH_USER_BY' |
        translate}}</strong>
      <bzg-select [placeholder]="'USER_GROUPS_BY_USER.SELECT_A_CATEGORY' | translate"
        [value]="selectedFilterColumnsResources" (valueChange)="changeFilterColumn($event)">
        <bzg-option *ngFor="let filterColumn of filterColumnsResources | keyvalue" [value]="filterColumn.key">
          {{ filterColumn.value | translate }}
        </bzg-option>
      </bzg-select>
    </div>

    <div class="bmc-working-time-schema-detail__section bz-space--inline-m bz-space--stack-s"
      [ngClass]="{'autocomplete-active': selectedFilterColumnsResources, 'autocomplete-disable': !selectedFilterColumnsResources}">
      <strong class="bz-space--stack-xs bmc-working-time-schema-detail__label">{{'USER_GROUPS_BY_USER.SEARCH_USER' |
        translate}}</strong>
      <bzg-autocomplete [placeholder]="'USER_GROUPS_BY_USER.SEARCH_AN_USER_TO_ADD' | translate" [optionSize]="'medium'"
        [displayWith]="displayFn" (valueChange)="getUserFilter($event)" (optionSelected)="userSelected($event.value)"
        id="userAutocomplete">
        <bzg-option *ngFor="let user of filteredUsers" [value]="user">
          <div class="bz-initials bz-space--inline-s" *ngIf="propertyDisplay == 'fullName'">{{ user.fullName.trim().charAt(0).toUpperCase() }}
          </div>
          <div class="bz-initials bz-space--inline-s" *ngIf="propertyDisplay == 'contactEmail'">{{ user.contactEmail.trim().charAt(0).toUpperCase() }}
          </div>
          <div class="bz-initials bz-space--inline-s" *ngIf="propertyDisplay == 'userName'">{{ user.userName.trim().charAt(0).toUpperCase() }}
          </div>
          <div class="bz-option__info">
            <span class="bz-option__title" *ngIf="propertyDisplay == 'fullName'">{{ user.fullName }}</span>
            <span class="bz-option__title" *ngIf="propertyDisplay == 'contactEmail'">{{ user.contactEmail }}</span>
            <span class="bz-option__title" *ngIf="propertyDisplay == 'userName'">{{ user.userName }}</span>
          </div>
        </bzg-option>
      </bzg-autocomplete>
    </div>

    <div class="bmc-working-time-schema-detail__section bz-space--inline-m bz-space--stack-s">
      <strong class="bz-space--stack-xs bmc-working-time-schema-detail__label">{{'WORKING_TIME_SCHEMA.BASE_CALENDAR' |
        translate}}</strong>
      <bzg-select [placeholder]="'USER_GROUPS_BY_USER.SELECT_A_CATEGORY' | translate"
        [(ngModel)]="idBaseCalendarSelected" [disabled]="!selectedUser">
        <bzg-option *ngFor="let baseCalendar of baseCalendars" [value]="baseCalendar.idWorkingTimeSchema"
          (selectionChanged)="onBaseCalendarChanged(baseCalendar)">{{baseCalendar.wtsName}}
        </bzg-option>
      </bzg-select>
    </div>
  </div>

  <div class="bmc-working-legend-lists">
    <div>
      <strong class="bmc-working-time-schema-detail__label bz-space--stack-s">
        {{'WORKING_TIME_SCHEMA.COMPANY' | translate}}
      </strong>

      <ul class="bmc-working-time-schema-detail-legends__list">
        <li class="bmc-working-time-schema-detail-legends__item bz-space--inline-m bz-space--stack-s">
          <div class="bmc-working-legend bmc-working-legend-working"></div>
          <label class="bz-font-size--body-small">{{'WORKING_TIME_SCHEMA.LEYEND_WORKING' | translate}}</label>
        </li>
        <li class="bmc-working-time-schema-detail-legends__item bz-space--inline-m bz-space--stack-s">
          <div class="bmc-working-legend bmc-working-legend-non-working"></div>
          <label class="bz-font-size--body-small">{{'WORKING_TIME_SCHEMA.LEYEND_NONWORKING' | translate}}</label>
        </li>
        <li class="bmc-working-time-schema-detail-legends__item bz-space--inline-m bz-space--stack-s">
          <div class="bmc-working-legend bmc-working-legend-edited-working-hours"></div>
          <label class="bz-font-size--body-small">{{'WORKING_TIME_SCHEMA.LEYEND_EDITED_DAYS' | translate}}</label>
        </li>
        <li class="bmc-working-time-schema-detail-legends__item bz-space--inline-m bz-space--stack-s">
          <div class="bmc-working-legend bmc-working-legend-edited-non-working-hours"></div>
          <label class="bz-font-size--body-small">{{'WORKING_TIME_SCHEMA.LEYEND_EDITED_HOURS' | translate}}</label>
        </li>
      </ul>
    </div>

    <div>
      <strong class="bmc-working-time-schema-detail__label bz-space--stack-s">
        {{'WORKING_TIME_SCHEMA.USER' | translate}}
      </strong>

      <ul class="bmc-working-time-schema-detail-legends__list">
        <li class="bmc-working-time-schema-detail-legends__item bz-space--inline-m bz-space--stack-s">
          <div class="bmc-working-legend bmc-working-legend-user-edited-working-hours"></div>
          <label class="bz-font-size--body-small">{{'WORKING_TIME_SCHEMA.LEYEND_EDITED_DAYS' | translate}}</label>
        </li>
        <li class="bmc-working-time-schema-detail-legends__item bz-space--inline-m bz-space--stack-s">
          <div class="bmc-working-legend bmc-working-legend-user-edited-non-working-hours"></div>
          <label class="bz-font-size--body-small">{{'WORKING_TIME_SCHEMA.LEYEND_EDITED_HOURS' | translate}}</label>
        </li>
      </ul>
    </div>
  </div>
</div>